const typeFornitura = 'pods'

function doFunction () {
  this.$eventBus.emit('show-dialog-page', {
    page: 'pods-sospensioni-saldate',
    title: `Sospensioni ${typeFornitura} Saldate`,
    data: {type:typeFornitura},
    maximize: false,
  })
}

export default {
  'bindTo': 'this',
  'method': doFunction,
}
